export default __webpack_public_path__ + "static/media/location.fcd00d8c.png";